package views.representante

import androidx.compose.runtime.Composable
import androidx.compose.runtime.ComposeCompilerApi
import kotlinx.browser.document
import kotlinx.dom.clear
import lbTitulo
import org.jetbrains.compose.web.attributes.placeholder
import org.jetbrains.compose.web.css.FlexDirection.Companion.Row
import org.jetbrains.compose.web.dom.*
import org.jetbrains.compose.web.renderComposable
import org.w3c.dom.HTMLDivElement
import utils.ff
import utils.ff.Companion.gsNavePage
import utils.ff.Companion.println0
import utils.ffCopy
import utils.ffInverte

class principalREP {

    fun show() {
        gsNavePage = "#principalREP"

        val htmlDiv1 = document.getElementById("htmlDiv1") as HTMLDivElement
        htmlDiv1.clear()

        renderComposable(rootElementId = "htmlDiv1") {
            body()
            //if (lemp5 != null && lemp5!!.count() > 0)
            //body1(lemp5!!)
        }
    }

    @Composable
    fun body() {
        Div(attrs = { classes("dlg-pad-top-5") }) {

            Div(attrs = { classes("form-group") }) {
                Button(attrs = {
                    classes("btn", "dlg-mobbt100"); onClick { _ ->
                    clickRelatorios()
                }
                }
                ) {
                    Text("Relatórios")
                }
            }

        }


    }

    //******************************************************************************** INICIO DOS EVENTOS

    //quando vazio vai fazer o retorno
    fun ffNavePage(_destino: String) {

        var sDest = _destino
        //descobre o a ultima tela aberta
        if (sDest.equals("")) {

            //println0("retorna um nível")

            sDest = gsNavePage.ffInverte()
            sDest = sDest.ffCopy(0, sDest.indexOf("#") + 1)
            sDest = sDest.ffInverte()
            //remove string
            gsNavePage = gsNavePage.replace(sDest, "")
            sDest = sDest.replace("#", "")
            //pega o que sobrou
            sDest = gsNavePage.ffInverte()
            sDest = sDest.ffCopy(0, sDest.indexOf("#") + 1)
            sDest = sDest.ffInverte()
            sDest = sDest.replace("#", "")
            // println0("retorna um nível " + sDest)
        } else {
            gsNavePage = "${gsNavePage}#$sDest"
        }

        lbTitulo!!.innerText = ""

        println0(sDest)
        if (sDest.equals("rep001"))
            rep001().show()
        else if (sDest.equals("rep003"))
            rep003().show()
        else if (sDest.equals("rep004"))
            rep004().show()
        else if (sDest.equals("rep005"))
            rep005().show()
        else if ((sDest.equals("principalREP")) || sDest.equals(""))
            principalREP().show()
        //ff.println0(gsNavePage)
    }

    fun clickRelatorios() {
        ffNavePage("rep001")
    }

}